import React, { MutableRefObject } from 'react';
import TabContext from '@mui/lab/TabContext';

import { useSelector } from 'react-redux';
import { TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { ArticleOutlined } from '@mui/icons-material';

import { selectCommandByNodeId, State } from '@store/index';
import { NodeField, NodeFieldType } from '../../';
import { Chatbot } from '@common/Node/CompletionChatbot';
import { ModuleParameters } from '@common/Node/NodeSidebar/Custom/ModuleParameters';
import { NodeInputExpression, NodeSidebar, NodeSidebarTab, NodeSidebarTabsContainer } from '@common/Node/NodeSidebar';
import { NodeData } from '@common/Node/NodeSidebar/NodeData';

interface Props {
  tab: string;
  setTab: React.Dispatch<string>;
  start: () => void;
  pause: () => void;
  reset: () => void;
  abortControllerRef: MutableRefObject<AbortController | null>;
}

export const ModuleTabs: React.FC<Props> = ({ tab, setTab, abortControllerRef, start, pause, reset }) => {
  const trace = useSelector((state: State) => state.tabs.active.run);

  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  if (!command) return null;

  const fields = command.fields;
  const inputFields = fields.filter((field) => field.type === NodeFieldType.Input);
  const parameterFields = fields.find((field) => field.type === NodeFieldType.ModuleParameter);
  const isTrace = trace?.id || trace?.running;

  if (isTrace) {
    return (
      <NodeSidebar>
        <Chatbot abortControllerRef={abortControllerRef} start={start} pause={pause} reset={reset} />
      </NodeSidebar>
    );
  }

  return (
    <NodeSidebar>
      <TabContext value={tab}>
        <NodeSidebarTabsContainer color={command.config.background}>
          <TabList onChange={(_, newTab) => setTab(newTab)}>
            <Tab disableRipple label='Node' value='1' />
            <Tab title='Data' disableRipple iconPosition='start' icon={<ArticleOutlined />} value='2' />
          </TabList>
        </NodeSidebarTabsContainer>
        <TabPanel value='1'>
          <NodeSidebarTab>
            {inputFields.map((field: NodeField) => (
              <NodeInputExpression key={field.id} field={field} command={command} />
            ))}
            {parameterFields && <ModuleParameters command={command} field={parameterFields} />}
          </NodeSidebarTab>
        </TabPanel>
        <TabPanel value='2'>
          <NodeData command={command} />
        </TabPanel>
      </TabContext>
    </NodeSidebar>
  );
};
